module.exports = __webpack_public_path__ + "img/logo.f88d34b4.svg";